// HowRespiteCareWorksSection.js
import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import howRespiteCareWorksImage from '../assets/how-respite-care-works-image.jpg';

const HowRespiteCareWorksSection = () => {
  const services = [
    'Follow a personalised care plan, delivered by a carer carefully matched to your loved one\'s needs and personality',
    'Help prevent carer burnout and reduce the emotional strain of providing constant care',
    'Support your well-being, so you can continue caring with energy, patience, and peace of mind',
    'Give you time to rest, recharge, and return to caring feeling renewed'
  ];

  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative">
            <img
              src={howRespiteCareWorksImage}
              alt="A smiling older man at home"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Respite Care
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              How Respite Care Works
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-8 max-w-lg">
              <p>
                When you get in touch with B & N Enterprise, one of our respite care team will arrange a free in-home assessment to understand your needs and those of your loved one. Our flexible, experienced carers are ready to step in, whether you need a few hours of support each week or around-the-clock care.
              </p>

              <p className="text-bnInk font-medium">Our respite care services are designed to:</p>
            </div>

            <ul className="space-y-5 mb-10">
              {services.map((service, index) => (
                <li key={index} className="flex items-start gap-4">
                  <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full border border-bnAccent text-bnAccent">
                    <ArrowRight size={16} />
                  </span>
                  <span className="text-bnBody text-sm leading-relaxed">{service}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={16} />
              Call +61 480 804 640
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowRespiteCareWorksSection;
